import { mapToObjectDDL } from "../../common/mapper";
import { v4 as uuidv4 } from "uuid";
import * as R from "ramda";
import moment from "moment";
import Api from "../../../Services/Api";
import { GenericSequenceType } from "../../common/Constants";

// export const getCategoryType = (type) => {
//   switch (type) {
//     case "KSU":
//       return "KSU_TYPE";
//     case "Hadiah":
//       return "GIFT_TYPE";
//     case "OtherItem":
//       return "OTHER_ITEMS_TYPE";
//     case "Part":
//       return "PART_TYPE";
//     default:
//       return "KSU_TYPE";
//   }
// };

export const getDataDetail = (type, data) => {
  if (!Array.isArray(data)) return [];

  switch (type) {
    case "QR":
      return data.map((item) => {
        const part = item?.part || {};
        const locator = item?.locatorId || {};
        const orderType = item?.orderType || "";

        return {
          id: uuidv4(),
          partCode: mapToObjectDDL(part.kodePart, part.kodePart),
          partName: mapToObjectDDL(part.partName, part.kodePart),
          categoryName: part.partCategory?.value || null,
          quantity: item.quantity || 0,
          purchaseOrderNo: item.purchaseOrderNo || "",
          orderType: orderType
            ? mapToObjectDDL(
                orderType.charAt(0).toUpperCase() +
                  orderType.slice(1).toLowerCase(),
                orderType
              )
            : null,
          hotlineOrderNo: item.hotlineOrderNo || "",
          locatorId: mapToObjectDDL(locator.nameLocation, locator.kodeLocation),
          saved: true,
          locatorName: locator.nameLocation || "",
          barcode: item.barcode,
          canEdit: item.canEdit
        };
      });

    case "NOQR":
      return data.map((item) => {
        const part = item?.part || {};
        const locator = item?.locatorId || {};
        const orderType = item?.orderType || "";

        return {
          id: uuidv4(),
          partCode: mapToObjectDDL(part.kodePart, part.kodePart),
          partName: mapToObjectDDL(part.partName, part.kodePart),
          categoryName: part.partCategory?.value || null,
          quantity: item.quantity || 0,
          purchaseOrderNo: item.purchaseOrderNo || "",
          orderType: orderType
            ? mapToObjectDDL(
                orderType.charAt(0).toUpperCase() +
                  orderType.slice(1).toLowerCase(),
                orderType
              )
            : null,
          hotlineOrderNo: item.hotlineOrderNo || "",
          locatorId: mapToObjectDDL(locator.nameLocation, locator.kodeLocation),
          saved: true,
          locatorName: locator.nameLocation || "",
        };
      });

    default:
      return [];
  }
};

export const getDataDetailView = (type, data) => {
  if (!Array.isArray(data)) return [];
  console.log(data);
  
  switch (type) {
    case "QR":
      return data.flatMap((item) => {
        const part = item?.part || {};
        const locator = item?.locatorId || {};
        const orderType = item?.orderType || "";
        const barcodes = item?.barcode || [];

        // kalau tidak ada barcode, tetap tampilkan 1 row
        if (!barcodes.length) {
          return [
            {
              id: uuidv4(),
              partCode: mapToObjectDDL(part.kodePart, part.kodePart),
              partName: mapToObjectDDL(part.partName, part.kodePart),
              categoryName: part.partCategory?.value || null,
              quantity: item.quantity || 0,
              purchaseOrderNo: item.purchaseOrderNo || "",
              orderType: orderType
                ? mapToObjectDDL(
                    orderType.charAt(0).toUpperCase() +
                      orderType.slice(1).toLowerCase(),
                    orderType
                  )
                : null,
              hotlineOrderNo: item.hotlineOrderNo || "",
              locatorId: mapToObjectDDL(
                locator.nameLocation,
                locator.kodeLocation
              ),
              saved: true,
              locatorName: locator.nameLocation || "",
              barcode: null, // tidak ada barcode
            },
          ];
        }

        // kalau ada barcode, looping semua barcode jadi satu row per barcode
        return barcodes.map((bc) => ({
          id: uuidv4(),
          partCode: mapToObjectDDL(part.kodePart, part.kodePart),
          partName: mapToObjectDDL(part.partName, part.kodePart),
          categoryName: part.partCategory?.value || null,
          quantity: 1, // karena per-barcode = 1 pcs
          purchaseOrderNo: item.purchaseOrderNo || "",
          orderType: orderType
            ? mapToObjectDDL(
                orderType.charAt(0).toUpperCase() +
                  orderType.slice(1).toLowerCase(),
                orderType
              )
            : null,
          hotlineOrderNo: item.hotlineOrderNo || "",
          locatorId: mapToObjectDDL(locator.nameLocation, locator.kodeLocation),
          saved: true,
          locatorName: locator.nameLocation || "",
          barcode: bc, // tiap baris pegang 1 barcode
        }));
      });

    case "NOQR":
      return data.map((item) => {
        const part = item?.part || {};
        const locator = item?.locatorId || {};
        const orderType = item?.orderType || "";

        return {
          id: uuidv4(),
          partCode: mapToObjectDDL(part.kodePart, part.kodePart),
          partName: mapToObjectDDL(part.partName, part.kodePart),
          categoryName: part.partCategory?.value || null,
          quantity: item.quantity || 0,
          purchaseOrderNo: item.purchaseOrderNo || "",
          orderType: orderType
            ? mapToObjectDDL(
                orderType.charAt(0).toUpperCase() +
                  orderType.slice(1).toLowerCase(),
                orderType
              )
            : null,
          hotlineOrderNo: item.hotlineOrderNo || "",
          locatorId: mapToObjectDDL(locator.nameLocation, locator.kodeLocation),
          saved: true,
          locatorName: locator.nameLocation || "",
          barcode: null,
        };
      });

    default:
      return [];
  }
};

export const getValueItemFromArrayDDL = (object, key) => {
  if (
    object?.[key] === undefined ||
    R.isNil(object[key]) ||
    R.isEmpty(object[key])
  ) {
    return [];
  }

  return Array.isArray(object[key].value)
    ? object[key].value.map((item) => {
        return { kode: item.kode, qty: Number(item.jumlah) };
      })
    : [];
};

export const validateDataItem = (obj, hasHotline) => {
  const fieldsToValidate = [
    "partCode",
    "partName",
    "orderType",
    "locatorId",
    "quantity"
  ];

  const errors = {};

  fieldsToValidate.forEach((field) => {
    const value = obj[field];
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (typeof value === "object" && !value.value)
    ) {
      errors[field] = "Field wajib diisi";
    }
  });

  const qty = Number(obj["quantity"]);
  if (!qty || qty <= 0) {
    errors["qty"] = "Field wajib diisi";
  }

  if (hasHotline && (!obj.hotlineOrderNo || obj.hotlineOrderNo === "")) {
    errors["hotlineOrderNo"] = "Field wajib diisi";
  }

  return errors;
};

// export const filterInitialValue = {
//   idPackage: null,
//   packageName: null,
//   cabangBerlaku: [],
//   kodeVariant: null,
//   startDate: null,
//   endDate: null,
//   gracePeriod: null,
//   noPeriod: null,
// };

export const fetchDataItem = async (type, body) => {
  try {
    const res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart({
      paramFilters: { category: body },
    });

    const data = res?.data?.data || [];

    const filteredData = data.filter((item) => {
      if (type === "QR") return item.qrCode === true;
      if (type === "NOQR") return item.qrCode === false;
    });

    return filteredData.map((item) => ({
      value: item.kodePart,
      label: item.partName,
      partCategory: item.partCategory,
      satuan: item.satuan,
      qrCode: item.qrCode,
    }));
  } catch (error) {
    console.error(`Error fetching data for type ${type}:`, error);
    return [];
  }
};

export const getSupplierExpOptions = (data) => {
  return data.map((item) => {
    return {
      value: item.supplierCode,
      label: item.supplierCode,
      name: item.supplierName,
    };
  });
};

export const getSupplier = (data) => {
  return data.map((item) => {
    return {
      value: item.supplierCode,
      label: item.supplierName,
      name: item.supplierName,
    };
  });
};

export const constructGenSeqPayload = (kodeCabang) => {
  return {
    seqType: GenericSequenceType.RECEIVING_PART_NOS,
    nosDealerCode: kodeCabang,
    transactionType: GenericSequenceType.RECEIVING_PART_NOS,
  };
};
